import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {UppyHelper} from "../../utils/uppyHelper";

declare var ko: any;

export class modImport_template extends vnTemplate {

    public uppyHelper: any;
    public folderIdMap: Record<string, string> = {};

    protected getTemplateHtml(): string {
        return `
            <div class="w-form">
                <div class="form-body no-padding">
                    <div id="mod-import-drag-drop" style="margin-bottom: 1rem"></div>
                </div>
            </div>
        `;
    }

    protected initPartial(): void {
    }

    protected getMainElementClasses(): Array<string> {

        return ["w-form", "w-form-large"];
    }

    protected buildViewModel(): any {

        return {
            uppyConfigOptions: ko.observable({
                maxNumberOfFiles: 500,
                endpoint: 'https://ggmods.com/tusd',
                locale: {
                    strings: {
                        dropPasteFiles: 'Drop folders here or %{browseFolders}',
                        browseFiles: 'browse folders'
                    }
                }

            }),
        }
    }

    protected getTemplateName(): string {

        return "modImport_template";
    }

      // //file uploader
    public intilizeFileUploaders() {
        
        const uppyConfigOptions = this.getTemplateViewModel().uppyConfigOptions();
        if (!uppyConfigOptions) {
            return;
        }

        this.uppyHelper = new UppyHelper(
            "mod-import-drag-drop",
            uppyConfigOptions,
            (file) => {return this.handleBeforeFileAdded(file);},
            (req, file) => {this.handleRequestHeaders(req, file);},
            (file) => {this.handleUploadComplete(file);}
        );
    }

    public handleRequestHeaders(req, file) {
        
        let folderName = null
        if (file.meta && file.meta.relativePath) {
            const segments = file.meta.relativePath.split('/');
            if (segments.length > 0){ 
                folderName = segments[0];
            }
        }

        if (folderName) {

            // Reuse the same random ID for the same folder
            if (!this.folderIdMap[folderName]) {
                const randomSuffix = Math.random().toString(36).substring(2, 8);
                this.folderIdMap[folderName] = `${folderName}_${randomSuffix}`;
            }

            const finalFolderName = this.folderIdMap[folderName];

            req.setHeader('modderid', finalFolderName);
            req.setHeader('dir', 'modinjections');
        }
        
        return req;
    }

    public handleBeforeFileAdded(file) {
        return file;
    }

    public handleUploadComplete(file){

    }
}


// WEBPACK FOOTER //
// ./js/components/templates/modImport_template.ts